var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7642 14.4972C15.8193 14.5524 15.8631 14.6179 15.8929 14.69C15.9228 14.7621 15.9382 14.8393 15.9382 14.9173C15.9382 14.9953 15.9228 15.0726 15.8929 15.1447C15.8631 15.2167 15.8193 15.2822 15.7642 15.3374C15.709 15.3926 15.6435 15.4363 15.5714 15.4662C15.4993 15.496 15.4221 15.5114 15.3441 15.5114C15.2661 15.5114 15.1888 15.496 15.1167 15.4662C15.0447 15.4363 14.9792 15.3926 14.924 15.3374L10.0003 10.413L5.07666 15.3374C4.96525 15.4488 4.81414 15.5114 4.65658 15.5114C4.49902 15.5114 4.34791 15.4488 4.2365 15.3374C4.12509 15.226 4.0625 15.0749 4.0625 14.9173C4.0625 14.7598 4.12509 14.6087 4.2365 14.4972L9.16092 9.57357L4.2365 4.6499C4.12509 4.53849 4.0625 4.38738 4.0625 4.22982C4.0625 4.07226 4.12509 3.92116 4.2365 3.80974C4.34791 3.69833 4.49902 3.63574 4.65658 3.63574C4.81414 3.63574 4.96525 3.69833 5.07666 3.80974L10.0003 8.73416L14.924 3.80974C15.0354 3.69833 15.1865 3.63574 15.3441 3.63574C15.5016 3.63574 15.6527 3.69833 15.7642 3.80974C15.8756 3.92116 15.9382 4.07226 15.9382 4.22982C15.9382 4.38738 15.8756 4.53849 15.7642 4.6499L10.8397 9.57357L15.7642 14.4972Z",
    fill: "#3E3E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSymbol);
export default __webpack_public_path__ + "static/media/CrossSymbol.b985bdad5c1c241dd110f025acf52cd2.svg";
export { ForwardRef as ReactComponent };